import { Modifications } from '@app/evaluation-core/modifications'
import { GolferShortName } from '@app/evaluation-core/types'
import theme from '@app/ui/theme'
import styled, { css } from 'styled-components'
import _styled from 'styled-components/native'

interface TeeContainerProps {
  collapsed: boolean
  disabled?: boolean
}

const teeContainerWidth = 'auto'
const isPhone = window.innerWidth <= 767

export const TeeContainer = styled.div<TeeContainerProps>`
  width: ${(props: TeeContainerProps) =>
    props.collapsed ? (!isPhone ? '50px' : '30px') : `${teeContainerWidth}px`};

  margin-right: 0px;

  &.disabled {
    opacity: 0.6;
  }

  margin-left: ${!isPhone ? '10px' : '6px'};
  margin-right: ${!isPhone ? '10px' : '6px'};
  height: 100%;
  padding: ${!isPhone ? '5px' : '3px'};
  padding-top: ${!isPhone ? '5px' : '3px'};
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.disabled : theme.colors.primary};
  min-width: ${(props: TeeContainerProps) =>
    props.collapsed ? (!isPhone ? '50px' : '30px') : teeContainerWidth};
  user-select: none;
  /*   border-radius: 5px; */
`

export const TeeRow = styled.div`
  display: flex;
  flex-direction: row;
  & > div {
    flex: 1;
    text-align: center;
  }
`

interface TeeRowTeeProps {
  selected: boolean
}

export const TeeRowTee = styled(TeeRow)`
  line-height: ${!isPhone ? '40px' : '20px'};
  font-size: ${!isPhone ? '16px' : '9px'};
  font-weight: ${!isPhone ? 600 : 300};
  color: rgba(0, 0, 0, 0.7) !important;
  background-color: ${(props: TeeRowTeeProps) =>
    props.selected ? theme.colors.secondary2 : theme.colors.white};

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: space-between;
`
export const StickyContainer = styled.div`
  z-index: 10;
  margin-left: ${!isPhone ? '10px' : '6px'};
  margin-right: ${!isPhone ? '10px' : '6px'};
  border-top: ${!isPhone ? '5px' : '3px'} solid ${theme.colors.primary};
  border-right: ${!isPhone ? '5px' : '3px'} solid ${theme.colors.primary};
  border-left: ${!isPhone ? '5px' : '3px'} solid ${theme.colors.primary};
  border-top-left-radius: ${!isPhone ? '7px' : '4px'};
  border-top-left-radius: ${!isPhone ? '7px' : '4px'};
  border-top-right-radius: ${!isPhone ? '7px' : '4px'};
  border-top-right-radius: ${!isPhone ? '7px' : '4px'};
`

export const TeeRowTeeInfo = _styled.TouchableOpacity`
  max-width: ${!isPhone ? '50px' : '30px'} !important;
  float: left;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${!isPhone ? '50px' : '30px'};
  overflow: hidden;
`

export const TeeRowTeeLabel = _styled.TouchableOpacity`
  text-align: center;
`

export const TeeRowTeeLabelText = _styled.Text`
    line-height: ${!isPhone ? '40px' : '20px'};
    font-size: ${!isPhone ? '16px' : '9px'};
  font-weight:  ${!isPhone ? 460 : 350};;
  color: #191919;
  text-align: center;
  white-space: nowrap;
`
export const TeeRowTeeNameLabelText = _styled.Text`
  line-height: ${!isPhone ? '36px' : '20px'};
  font-size:  ${!isPhone ? '19px' : '10px'};
  font-weight: ${!isPhone ? 460 : 350};;
  color: #191919;
  text-align: center;
  white-space: nowrap;
`

export const TeeRowTeeExpand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${!isPhone ? '50px' : '26px'};
  z-index: 100;
  max-width: ${!isPhone ? '50px' : '26px'};
  cursor: pointer;
`

interface TeeRowGenderProps {
  golfer: GolferShortName
  tee: boolean
}

export const TeeRowTeeName = styled.div`
  background-color: white;
  font-size: ${!isPhone ? 15 : 10};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '40px' : '20px'};
  letter-spacing: ${!isPhone ? 0.5 : 0.25};
  color: #666;
`

export const TeeRowGender = styled(TeeRow)`
  background-color: white;
  font-size: ${!isPhone ? '15px' : '10px'};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? 40 : 20};
  letter-spacing: 0.5px;
  color: #666;

  /* & > div {
    font-weight: 500;
  }

  & > div:first-child {
    opacity: ${(props: TeeRowGenderProps) =>
    props.tee && props.golfer.includes('M') ? 1 : 0.7};
  }

  & > div:last-child {
    opacity: ${(props: TeeRowGenderProps) =>
    props.tee && props.golfer.includes('W') ? 1 : 0.7};
  } */
`

export const TeeRowScorer = styled(TeeRow)`
  color: #666;
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '40px' : '20px'};
  & > div {
  }
  & > div:last-child {
    border-right: 0;
  }
  background-color: white;

  box-shadow: 0 0px ${!isPhone ? '4px' : '2px'} 0 ${theme.colors.dark1};
  border-bottom-left-radius: ${!isPhone ? '10px' : '5px'};
  border-bottom-left-radius: ${!isPhone ? '10px' : '5px'};
  & > div:first-child {
    border-bottom-left-radius: ${!isPhone ? '10px' : '5px'};
  }
  & > div:last-child {
    border-bottom-right-radius: ${!isPhone ? '10px' : '5px'};
  }
  padding-bottom: 2px;
`

interface TeeRowScorerItemProps {
  selected?: boolean
}

export const TeeRowScorerItem = styled.a<TeeRowScorerItemProps>`
  display: block;
  margin: 0 auto;
  line-height: ${!isPhone ? '40px' : '20px'};
  font-size: ${!isPhone ? '18px' : '10px'};
  font-weight: ${(props) =>
    props.selected ? (!isPhone ? 600 : 400) : !isPhone ? 400 : 200};
  background-color: ${(props) =>
    props.selected ? props.theme.colors.primary : props.theme.colors.white};
  color: ${(props) =>
    props.selected ? props.theme.colors.white : 'rgba(0,0,0,0.6)'};
`

export const TeeRowValue = styled(TeeRow)`
  font-size: ${!isPhone ? '16px' : '9px'};
  font-weight: ${!isPhone ? 400 : 20};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '40px' : '20px'};
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
  & > div {
    line-height: ${!isPhone ? '40px' : '20px'};
  }
  & > div:last-child {
    border-right: 0;
  }

  background: repeating-linear-gradient(
    46deg,
    #bfccd1,
    #bfccd1 1px,
    #d1dce2 1px,
    #d1dce2 9px
  );
`

export const TeeRowGroup = styled(TeeRow)`
  font-size: ${!isPhone ? '14px' : '8px'};
  font-weight: ${!isPhone ? 400 : 200};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '48px' : '24px'};
  cursor: pointer;
  user-select: none;

  & > div {
    border-right: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
    line-height: ${!isPhone ? '40px' : '20px'};
  }
  & > div:last-child {
    border-right: 0;
  }
`

interface TeeGridProps {
  collapsed?: boolean
}

interface ValueItemProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  onClick?: () => void
  children?: React.ReactNode
  disabled?: boolean
  modification?: Modifications | undefined
  modificationPercentage?: number
  overrideOpacity?: boolean
  last?: boolean
  collapsed?: boolean
}

function modificationColor(type: Modifications | undefined) {
  if (!type) {
    return '#fff'
  }
  switch (type) {
    case Modifications.ADJUSTED:
      return theme.colors.yellow
    case Modifications.AUTOMATIC:
      return '#FFF'
    case Modifications.NONE:
      return '#FFF'
    case Modifications.UPDATED:
      return theme.colors.updated
    default:
      return theme.colors.saved
  }
}

const getModifcationGradientString = (
  modification: Modifications | undefined,
  percentage = 0
) =>
  `linear-gradient(90deg, ${modificationColor(
    modification
  )} ${percentage}%, #fff ${0}%)`

const getBackgroundColor = (
  disabled?: boolean,
  modification?: Modifications,
  modificationPercentage?: number,
  last?: boolean
) => {
  if (disabled) {
    return 'rgba(223,233,236,.4)'
  }
  if (last) {
    return theme.colors.primary
  }
  return getModifcationGradientString(modification, modificationPercentage)
}

const lastCss = css`
  outline: 3px solid ${theme.colors.primary};
  outline-offset: ${!isPhone ? '-3px' : '-1.5px'};
`

export const ValueItem = styled.div<ValueItemProps>`
  ${({ overrideOpacity, disabled, modification, modificationPercentage }) => `
    background: ${getBackgroundColor(
      disabled,
      modification,
      modificationPercentage
    )};
    font-weight: ${!isPhone ? 600 : 300};
    display: flex;
    font-size:  ${!isPhone ? '17px' : '9px'};
    flex-direction: row;
    justify-content: center;
    align-items: center;
border-right: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
    border-bottom: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
    border-top: ${!isPhone ? '1px' : '0.5px'} solid transparent;
    border-left: ${!isPhone ? '1px' : '0.5px'} solid transparent;
    box-sizing: border-box;
    & > div:nth-child(2) {
      font-size:  ${!isPhone ? '14px' : '7px'};
      color: #666;
      margin-top: ${!isPhone ? '11px' : '6px'};
      font-weight: ${!isPhone ? 500 : 250};
      width: ${!isPhone ? '12px' : '6px'};
      overflow: hidden;
      text-align: center;
    }
  `}
  ${({ last }) => last && lastCss};
  min-width: ${({ collapsed }) =>
    collapsed ? '100%' : !isPhone ? '50px' : '25px'};
`

export const DisplayText = styled.span`
  color: rgba(0, 0, 0, 0.7);
  font-size: ${!isPhone ? '24px' : '12px'};
`
export const ShotText = styled.span`
  color: rgba(0, 0, 0, 0.7);
  font-size: ${!isPhone ? '14px' : '8px'};
  position: absolute;
  right: 0;
  transform: translateX(100%);
  bottom: ${!isPhone ? '-7px' : '-4px'};
`

export const RevisionText = styled.span`
  text-align: center;
  flex: 1;
  display: flex;
  justify-content: center;
  padding-top: ${!isPhone ? '4px' : '2px'};
`

export const TeeColorEllipse = styled.div<{ color: string }>`
  width: ${!isPhone ? '14px' : '7px'};
  height: ${!isPhone ? '14px' : '7px'};
  border: 1px solid #ccc;
  border-radius: 999px;
  background-color: ${(props) => props.color};
  margin-right: ${!isPhone ? '12px' : '6px'};
  margin-top: auto;
  margin-bottom: auto;
`

export const TeeLengthContainer = styled.div`
  margin-left: auto;
`
